import { buttonClasses as r } from "@mui/material";
const t = {
  styleOverrides: {
    sizeSmall: ({ theme: o }) => ({
      ...o.typography.body2
    }),
    sizeMedium: ({ theme: o }) => ({
      ...o.typography.body1
    }),
    sizeLarge: ({ theme: o }) => ({
      ...o.typography.body1
    }),
    root: ({ theme: o }) => ({
      [`&:not(&.${r.disabled})`]: {
        [`&.${r.outlinedError}`]: {
          borderColor: o.palette.error.main
        },
        [`&.${r.outlinedInfo}`]: {
          borderColor: o.palette.info.main
        },
        [`&.${r.outlinedPrimary}`]: {
          borderColor: o.palette.primary.main
        },
        [`&.${r.outlinedSecondary}`]: {
          borderColor: o.palette.secondary.main
        },
        [`&.${r.outlinedSuccess}`]: {
          borderColor: o.palette.success.main
        },
        [`&.${r.outlinedWarning}`]: {
          borderColor: o.palette.warning.main
        }
      }
    })
  }
};
export {
  t as button
};
//# sourceMappingURL=button2.mjs.map
